import { useState } from 'react';

import DOMPurify from 'isomorphic-dompurify';

interface ShowMoreTextProps {
  charLimit?: number;
  text: string;
  buttonClassName?: string;
  showMoreText?: string;
  showLessText?: string;
  className?: string;
  onToggleExpanded?: (isExpanded: boolean) => void;
}

const ReadMoreText = ({
  charLimit = 200,
  text,
  buttonClassName = 'inline-flex font-medium text-primary',
  showMoreText = 'Show More ››',
  showLessText = '‹‹ Show Less',
  className = 'inner-html',
  onToggleExpanded = () => {},
}: ShowMoreTextProps) => {
  const shouldTruncate = text.length > charLimit;
  const [isExpanded, setIsExpanded] = useState(!shouldTruncate);
  const displayedText = isExpanded ? text : `${text.slice(0, charLimit).trim()}…`;
  const label = isExpanded ? showLessText : showMoreText;

  const toggleExpanded = () => {
    setIsExpanded((oldState) => {
      onToggleExpanded(!oldState);
      return !oldState;
    });
  };

  return (
    <>
      <span
        className={className}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(displayedText) }}
      />
      {isExpanded && ' '}
      {shouldTruncate ? (
        <button className={buttonClassName} onClick={toggleExpanded}>
          {label}
        </button>
      ) : null}
    </>
  );
};

export default ReadMoreText;
